import React, { FC, useEffect, useState } from "react";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineDot,
  TimelineConnector,
  TimelineContent,
  timelineItemClasses,
} from "@mui/lab";
import TimeHelper from "../../../../../utils/time";
import { RefundQuery } from "../../../../../services/query";
import { SCUILoading } from "../../../../../atomic/atoms";
import { NoResultFoundComponent } from "../../../../CustomerManagement/components/NoResultFoundComponent/NoResultFoundComponent";

export const SCUIRefundHistory: FC<{ refundId?: any }> = ({ refundId }) => {
  const [refundHistoryList, setRefundHistoryList] = React.useState<any>();
  const [loading, setLoading] = useState(false);

  const GetRefundListHistory = () => {
    setLoading(true);
    RefundQuery.GetRefundListHistory({ refundId: refundId })
      .then((res: any) => {
        if (res.data.result) {
          setRefundHistoryList(res.data);
        }
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    GetRefundListHistory();
  }, []);

  return (
    <React.Fragment>
      {refundHistoryList ? (
        <Timeline
          sx={{
            [`& .${timelineItemClasses.root}:before`]: { flex: 0, padding: 0 },
          }}
        >
          {refundHistoryList &&
            refundHistoryList.result.map((item: any) => (
              <TimelineItem key={item?.date ?? `${item?.previousStatusName}-${item?.currentStatusName}`}>
                <TimelineSeparator>
                  <TimelineDot color="primary" />
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent>
                  {TimeHelper.formatDateHourSecond(item.date)} {item.firstName}{" "}
                  {item.lastName} <strong>{item.previousStatusName}</strong>{" "}
                  &#10148; <strong>{item.currentStatusName}</strong>
                </TimelineContent>
              </TimelineItem>
            ))}
        </Timeline>
      ) : loading ? (
        <SCUILoading />
      ) : (
        <NoResultFoundComponent
          errorText={"Ödeme Tarihçe Bilgileri Bulunamadı."}
        />
      )}
    </React.Fragment>
  );
};
